import { makeRESTApiRequest } from '../../helpers/api';
import { ENDPOINTS } from '../../helpers/constants';
import { getOptionsFromRecords } from './countyMunicipalityData';

const norm = s => (s || '').trim().toLowerCase();

export async function ensureCountyCreated(county, records) {
  const c = county?.trim();
  if (!c) return { skipped: true };

  const { countyNames } = getOptionsFromRecords(records || []);
  if (countyNames.some(n => norm(n) === norm(c))) {
    return { skipped: true };
  }

  const { response, error } = await makeRESTApiRequest({
    endpoint: ENDPOINTS.CREATE_COUNTY_MUNICIPALITY,
    method: 'POST',
    requestBody: { county: c }
  });

  if (error) return { error };
  const record =
    response && (response._id || response.id || typeof response.county === 'string') ? response : null;
  return record ? { record } : { error: 'Unexpected response when saving county' };
}

export async function ensureMunicipalityCreated(county, city, records) {
  const c = county?.trim();
  const t = city?.trim();
  if (!c || !t) return { skipped: true };

  const exists = (records || []).some(
    r => norm(r.county) === norm(c) && r.city != null && String(r.city).trim() && norm(r.city) === norm(t)
  );
  if (exists) return { skipped: true };

  const { response, error } = await makeRESTApiRequest({
    endpoint: ENDPOINTS.CREATE_COUNTY_MUNICIPALITY,
    method: 'POST',
    requestBody: { county: c, city: t }
  });

  if (error) return { error };
  const record =
    response && (response._id || response.id || typeof response.city === 'string') ? response : null;
  return record ? { record } : { error: 'Unexpected response when saving municipality' };
}
